import notificationSound from '@/assets/sound/notification-sound.mp3'

let audioEnabled = true;


// Function to play notification sound
export const playNotificationSound = () => {
  const audio = new Audio(notificationSound);
  if (audioEnabled) {
    audio.play().catch((error) => {
      console.error("Failed to play the notification sound", error);
    });
  } else {
    console.warn("Audio playback is not enabled yet. Waiting for user interaction.");
  }
};
